"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../utils/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- ADDABLE FIELDS : DEFINITION --------------- ++++++++++ */


var _default2 = {
  name: 'AddableFields',
  props: {
    fieldData: {
      type: 'array',
      default: [{
        id: "addablefield".concat((0, _index.generateId)()),
        value: "test value ".concat((0, _index.generateId)())
      }, {
        id: "addablefield".concat((0, _index.generateId)()),
        value: "test value ".concat((0, _index.generateId)())
      }, {
        id: "addablefield".concat((0, _index.generateId)()),
        value: "test value ".concat((0, _index.generateId)())
      }]
    },
    name: {
      type: 'string',
      default: 'addablefield'
    },
    label: {
      type: 'string',
      default: 'Enter value below:'
    },
    placeholder: {
      type: 'string',
      default: 'Type value ...'
    },
    defaultVal: {
      type: 'string'
    },
    newField: {
      type: 'function',
      default: function _default() {
        return console.log('newField');
      }
    },
    removeField: {
      type: 'function',
      default: function _default() {
        return console.log('removeField');
      }
    },
    handleChange: {
      type: 'function',
      default: function _default(text, id) {
        return console.log(text, id);
      }
    },
    ctaText: {
      type: 'string',
      default: 'Add a new variation'
    }
  }
};
exports.default = _default2;